module.exports = __webpack_public_path__ + "static/janesville-17c6a1da02c87d1b543f2b30db506c09.jpg";